import { PageActions } from "../../../../components/implementer/submissions"

export const data = ({ save, currentStepKey, stepsToOmit }) => {
  return {
    stepsToOmit,
    currentStepKey,
    title: "Nueva solicitud",
    actions: <PageActions save={save} />
  }
}
